export const TERMS_STRINGS = {
  en: {
    TITLE: 'Privacy Policy',
  },
  sv: {
    TITLE: 'Integritet',
  },
  nb: {
    TITLE: 'Integritet',
  },
  da: {
    TITLE: 'Persondatapolitik',
  },
} as const
